import styled, { css } from "styled-components"

export default function OrderHistoryItemFooterActionBtn({
  onActionClick,
  onDetailClick,
  actioBtnTxt,
  detailBtnTxt,
}) {
  return (
    <Block>
      {actioBtnTxt && onActionClick && (
        <ActionBtn
          className={detailBtnTxt && onDetailClick ? "mg-r-11" : null}
          onClick={onActionClick}
        >
          {actioBtnTxt}
        </ActionBtn>
      )}
      {detailBtnTxt && onDetailClick && (
        <DetailBtn onClick={onDetailClick}>{detailBtnTxt}</DetailBtn>
      )}
    </Block>
  )
}

const Block = styled.div`
  display: flex;
`

const buttonStyle = css`
  background-color: #fff;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  border: 1px solid #c4c4c4;
  border-radius: calc(100vw * (5 / 375));
  padding: calc(100vw * (12 / 375)) 0;
  width: 100%;
`

const ActionBtn = styled.button`
  ${buttonStyle}
  &.mg-r-11 {
    margin-right: calc(100vw * (11 / 375));
  }
`

const DetailBtn = styled.button`
  ${buttonStyle}
`
